const store = {
  state: {
    isFetchingData: false,
    hasNoData: false,
    fromFilterView: false
  },

  mutations: {
    SET_ERROR_DATA: (state, payload) => {
      state.hasNoData = payload;
    },
    SET_FROM_FILTER_VIEW: (state, payload) => {
      state.fromFilterView = payload;
    },
    SET_IS_FETCHING_DATA: (state, payload) => {
      state.isFetchingData = payload;
    }
  },

  getters: {
    GetHasNoData: state => state.hasNoData,
    GetFromFilterView: state => state.fromFilterView,
    GetIsFetchingData: state => state.isFetchingData
  }
};

export default store;
